export var icon_aKeyValue = require('@/assets/image/icon-aKeyValue.png');
export var icon_sellCar = require('@/assets/image/icon-sellCar.png');
export var icon_buyCar = require('@/assets/image/icon-buyCar.png');
export var icon_replacement = require('@/assets/image/replace-jump-icon.png');
export var icon_certificationOfTheQuery = require('@/assets/image/icon-certificationOfTheQuery.png');
export var icon_authorized = require('@/assets/image/authorized-stores.png');
export var url_share = 'https://usedcar.lynkco.com';
export var url_bundle = 'https://lynk-capp-prod.oss-cn-hangzhou.aliyuncs.com/lynkco2-prod';
export var url_cordova = 'https://h5.lynkco.com/lynkco3-aftersale/index.html#';
export var url_kefu = 'https://lkai.lynkco.com/kefu/static/h5/index.html?time=1640672585583&e=Q5SGjXDbcxmNUKTWL6kGKa&c=6000000784636799&state=service_h5&channel=escmall_app';
export var clientId = '21942113';
export var image_store = 'https://lynk-usedcar-prod.oss-cn-hangzhou.aliyuncs.com/config/store_picture.jpg';
export var image_quality_promise = 'https://lynk-usedcar-prod.oss-cn-hangzhou.aliyuncs.com/config/image-quality-promise.jpg';
export var image_selling_cars_process = 'https://lynk-usedcar-prod.oss-cn-hangzhou.aliyuncs.com/config/image-selling-cars-process.jpg';
export var image_valuation = 'https://lynk-usedcar-prod.oss-cn-hangzhou.aliyuncs.com/config/default.jpg';

// export const route_href = "http://192.168.110.83:9020/mobile/#/"
export var route_href = 'https://usedcar.lynkco.com/#/';
// https://usedcar-uat.lynkco.com/#/buy-car

// export const sellCar
export default {
  icon_aKeyValue: icon_aKeyValue,
  icon_sellCar: icon_sellCar,
  icon_buyCar: icon_buyCar,
  icon_replacement: icon_replacement,
  icon_certificationOfTheQuery: icon_certificationOfTheQuery,
  icon_authorized: icon_authorized,
  url_share: url_share,
  url_bundle: url_bundle,
  url_cordova: url_cordova,
  url_kefu: url_kefu,
  clientId: clientId,
  image_store: image_store,
  image_quality_promise: image_quality_promise,
  image_selling_cars_process: image_selling_cars_process,
  image_valuation: image_valuation,
  route_href: route_href
};